import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/app/crm")({
  ssr: false,
  head: () => ({ meta: [{ title: "CRM" }, { name: "robots", content: "noindex,nofollow" }] }),
  component: () => <Outlet />,
});
